import React from 'react';
import { QuoteIcon } from 'lucide-react';
const objections = ['How much will this cost?', 'Will they actually show up when they promise?', 'What if they damage my property?', "I don't have time for this."];
export function PainSection() {
  return <section className="w-full bg-white py-16 lg:py-24" data-id="element-182" data-mp="2uxvxbejsiutw">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 lg:grid-cols-[1fr_0.8fr] lg:gap-16" data-id="element-183" data-mp="2yyza1s6jkaqw">
        <div data-id="element-184" data-mp="2l82kybbtqbol">
          <h2 className="font-display text-3xl uppercase leading-tight text-forest-800 sm:text-4xl" data-id="element-185" data-mp="2l7aybq07foag">
            You&apos;ve been staring at that pile for three months
          </h2>
          <div className="mt-6 space-y-5 text-lg leading-relaxed text-ink-700" data-id="element-186" data-mp="2baxw23qlg243">
            <p data-id="element-187" data-mp="2g8zq1jpk5luc">
              The broken furniture. The old appliances taking up space. The yard waste. The
              construction debris from the renovation that finished months ago.
            </p>
            <p className="font-semibold text-ink-900" data-id="element-188" data-mp="278bbmnw95jgx">You know it needs to go.</p>
            <p data-id="element-189" data-mp="3rn0tnjs54s6n">But every time you think about it, something stops you.</p>
            <p data-id="element-190" data-mp="3rl7n04hj27yn">
              So you ignore it again. And again. And that small pile becomes a source of quiet
              stress every single day.
            </p>
            <p className="border-l-4 border-ember-500 pl-5 text-xl font-semibold text-forest-800" data-id="element-191" data-mp="5ergqmzeygxn">
              You&apos;re not lazy. You&apos;re not disorganized. You&apos;re human. The problem
              isn&apos;t the junk — it&apos;s that dealing with it feels complicated and expensive.
            </p>
          </div>
        </div>

        <div className="self-start rounded-lg bg-forest-50 p-7" data-id="element-192" data-mp="33vdaxp518nfg">
          <p className="font-display text-sm uppercase tracking-[0.18em] text-forest-700" data-id="element-193" data-mp="3in4c02464tl3">
            What stops you every time
          </p>
          <ul className="mt-5 space-y-4" data-id="element-194" data-mp="3dtszplgl7kls">
            {objections.map(text => <li key={text} className="flex gap-3 border-b border-forest-100 pb-4 text-base italic text-ink-700 last:border-0 last:pb-0" data-id="element-195" data-mp="2q4gu0vkgxuo8">
                <QuoteIcon className="mt-1 h-4 w-4 shrink-0 text-ember-500" aria-hidden="true" data-id="element-196" data-mp="p3trpjzs6p3k" />
                {text}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-14 max-w-4xl px-5 text-center lg:mt-20" data-id="element-197" data-mp="u0smm4r9r02t">
        <p className="text-lg text-ink-700" data-id="element-198" data-mp="yuwx2xzqtq8n">
          We&apos;ve talked to hundreds of homeowners across Oceanside, Carlsbad, Encinitas and all
          over North County. They all say the same thing:
        </p>
        <p className="mt-5 font-display text-2xl uppercase leading-snug text-forest-800 sm:text-3xl" data-id="element-199" data-mp="66skrtmo2ewz">
          &ldquo;I know I need to handle this. But the whole process feels overwhelming.&rdquo;
        </p>
        <div className="mt-8 grid gap-4 text-left sm:grid-cols-3" data-id="element-200" data-mp="f7qumsjsdgnh">
          {[['Big companies', 'Impersonal, expensive, slow.'], ['Craigslist', 'A gamble every single time.'], ['Doing it yourself', 'Exhausting, and risky on your back.']].map(([title, body]) => <div key={title} className="rounded-md border border-forest-100 bg-forest-50 p-5" data-id="element-201" data-mp="1vj32hn4homnz">
              <p className="font-display text-base uppercase text-forest-800" data-id="element-202" data-mp="25o2rb7pn5hto">{title}</p>
              <p className="mt-1 text-sm text-ink-700" data-id="element-203" data-mp="20o81z8lil0aq">{body}</p>
            </div>)}
        </div>
        <p className="mt-8 font-display text-xl uppercase text-ember-600" data-id="element-204" data-mp="1vxhu9opm8lcv">
          But what if there was a different way?
        </p>
      </div>
    </section>;
}